import React from "react";

function ArrowDown({ color }) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.33594 13.7617L4.02344 8.44922C3.65625 8.08203 3.65625 7.48828 4.02344 7.125L4.90625 6.24219C5.27344 5.875 5.86719 5.875 6.23047 6.24219L9.99609 10.0078L13.7617 6.24219C14.1289 5.875 14.7227 5.875 15.0859 6.24219L15.9687 7.125C16.3359 7.49219 16.3359 8.08594 15.9687 8.44922L10.6562 13.7617C10.2969 14.1289 9.70312 14.1289 9.33594 13.7617Z"
        fill={color}
      />
    </svg>
  );
}

export default ArrowDown;
